import { Component, OnInit } from '@angular/core';
import { ToastMessage, ToastService } from '../../services/toast-service';
import { NgClass } from '@angular/common';
import WarnIcon from '../../../../public/icons/warn.svg';
import DangerIcon from '../../../../public/icons/danger.svg';
import SuccessIcon from '../../../../public/icons/success.svg';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-toast',
  imports: [NgClass],
  templateUrl: './toast.html',
})
export class Toast implements OnInit {
  toasts: { id: number; data: ToastMessage }[] = [];

  sanitizedSvg!: SafeHtml;

  warnIcon = WarnIcon;
  dangerIcon = DangerIcon;
  successIcon = SuccessIcon;

  constructor(private toastService: ToastService, private sanitizer: DomSanitizer) {
    this.sanitizedSvg = this.sanitizer.bypassSecurityTrustHtml(this.warnIcon);
  }

  ngOnInit() {
    this.toastService.toasts$.subscribe((toast) => {
      const id = Date.now();
      this.sanitizedSvg = this.sanitizer.bypassSecurityTrustHtml(this.getIcon(toast.type));
      this.toasts.push({ id, data: toast });

      setTimeout(() => this.remove(id), 3500);
    });
  }

  remove(id: number) {
    this.toasts = this.toasts.filter((t) => t.id !== id);
  }

  getIcon(type: 'info' | 'success' | 'warn' | 'danger') {
    switch (type) {
      case 'danger':
        return this.dangerIcon;
      case 'warn':
        return this.warnIcon;
      case 'success':
        return this.successIcon;
      default:
        return '';
    }
  }
}
